// ローディング判定
jQuery(window).on("load", function() {
  jQuery("body").attr("data-loading", "true");
});

jQuery(function() {
  // スクロール判定
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (400 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }
  });
  if (window.matchMedia("(max-width: 750px)").matches) {
    /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
    jQuery(".g-nav-item-link._a").on("click", function(e) {
      let drawer = jQuery(".js-drawer");
      let targetClass = jQuery(drawer).attr("data-target");
      let ariaControls = jQuery(drawer).attr("aria-controls");

      jQuery("." + targetClass).toggleClass("is-checked");
      jQuery(body).toggleClass("is-checked");
      if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
        jQuery("#" + ariaControls).attr("aria-hidden", "false");
      } else {
        jQuery("#" + ariaControls).attr("aria-hidden", "ture");
      }

      if (jQuery(drawer).attr("aria-expanded") === "true") {
        jQuery(drawer).attr("aria-expanded", "false");
      } else {
        jQuery(drawer).attr("aria-expanded", "ture");
      }

      jQuery(this).toggleClass("active");
      jQuery(this)
        .closest(".menu-second")
        .slideToggle();
      jQuery(this)
        .not(jQuery(this).closest(".g-nav-item.child"))
        .children(".menu-second")
        .slideUp();
    });
  }

  // アコーディオンメニュー
  jQuery(".g-nav-item.child").on("click", function() {
    if (window.matchMedia("(max-width: 750px)").matches) {
      jQuery(this)
        .children(".g-nav-item-link")
        .toggleClass("active");
      jQuery(this)
        .children(".menu-second")
        .slideToggle();
      jQuery(".g-nav-item.child")
        .not(jQuery(this))
        .children(".menu-second")
        .slideUp();
    }
  });

  /* ドロワー */
  jQuery(".js-drawer").on("click", function(e) {
    e.preventDefault();
    let targetClass = jQuery(this).attr("data-target");
    let ariaControls = jQuery(this).attr("aria-controls");
    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery(body).toggleClass("is-checked");

    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "ture");
    }

    if (jQuery(this).attr("aria-expanded") === "true") {
      jQuery(this).attr("aria-expanded", "false");
    } else {
      jQuery(this).attr("aria-expanded", "ture");
    }
    return false;
  });

  jQuery(".sp-btn").on("click", function() {
    jQuery(this)
      .next()
      .slideToggle();
  });
});
/* 
var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - 120;
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
  }, 100);
} */

var headerHeight = jQuery("header").outerHeight();
var urlHash = location.hash;
let speed = 300;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);
  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - headerHeight;
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, speed);
  }, 100);
}

jQuery('a[href^="#"]:not(.no_somooth)').click(function() {
  let id = jQuery(this).attr("href");
  let speed = 300;
  let header_h = jQuery("header").outerHeight();
  let target = jQuery("#" == id ? "html" : id);
  let position = jQuery(target).offset().top - header_h;
  if ("fixed" !== jQuery("header").css("position")) {
    position = jQuery(target).offset().top;
  }

  console.log("ok");

  jQuery("html, body").animate(
    {
      scrollTop: position
    },
    speed
  );
  return false;
});

jQuery(function() {
  // aimation呼び出し
  if (jQuery(".js-scroll-trigger").length) {
    scrollAnimation();
  }

  // aimation関数
  function scrollAnimation() {
    jQuery(window).scroll(function() {
      jQuery(".js-scroll-trigger").each(function() {
        let position = jQuery(this).offset().top,
          scroll = jQuery(window).scrollTop(),
          windowHeight = jQuery(window).height();

        if (scroll > position - windowHeight + 200) {
          jQuery(this).addClass("active");
        }
      });
    });
  }
  jQuery(window).trigger("scroll");
});

//wait
jQuery(function() {
  "use waits";

  var dialog = document.getElementById("dialog");
  var waits = document.getElementsByClassName("wait");
  var cancel = document.getElementById("cancel");
  var scrollpos;

  for (let i = 0; i < waits.length; i++) {
    waits[i].addEventListener(
      "click",
      function() {
        dialog.style.visibility = "visible";
        dialog.style.opacity = 1;
        scrollpos = jQuery(window).scrollTop();
        jQuery("body")
          .addClass("fixed")
          .css({ top: -scrollpos });
      },
      false
    );
  }

  cancel.addEventListener("click", function() {
    jQuery("body")
      .removeClass("fixed")
      .css({ top: 0 });
    window.scrollTo(0, scrollpos);
    dialog.style.visibility = "hidden";
    dialog.style.opacity = 0;
  });
});

//headerスクロール fix
jQuery(window).on("scroll", function() {
  jQuery("header").css("left", -jQuery(window).scrollLeft());
});

if (window.matchMedia("(min-width: 769px)").matches) {
  /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
}
var _window = jQuery(window),
  _header = jQuery("header"),
  heroBottom;

_window.on("scroll", function() {
  /*         heroBottom1 = jQuery(".mv").height();
  heroBottom2 = jQuery(".header-logo").height();
  heroBottom = heroBottom1 - heroBottom2; */
  if (_window.scrollTop() > 20) {
    _header.addClass("transform");
  } else {
    _header.removeClass("transform");
  }
});
_window.trigger("scroll");

var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - 120;
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
    console.log(header);
    console.log(position);
  }, 100);
}

// 1.関数の定義
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

// 2.初期化
setHeight();

// 3.ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
window.addEventListener("resize", setHeight);

jQuery(function() {
  jQuery(".fm-namebox").each(function() {
    jQuery(this).on("click", function() {
      jQuery(this).toggleClass("on");
      jQuery(this)
        .next(".fm-content")
        .slideToggle();
      return false;
    });
  });
});
